import AutoLoginCheckContainer from 'modules/v2/containers/AutoLoginCheckContainer';

const AutoLoginCheck = () => {
  return <AutoLoginCheckContainer />;
};

export default AutoLoginCheck;
